import { Col, Row, Container } from "react-bootstrap";
import BusinessPropertySideBar from "../createJobsProfile/components/companySidebar/businesspropertySidebar";
import PropertyItemsCard from "../../components/PropertyItems/PropertyItems";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Managebuttons from "../../components/Manage_Buttons/index.js";
import BackArrow from "../../components/backArrow";
import { useGetCompanyByIdQuery } from "../../features/user/userApiSlice";
import { useLazyGetShopSuggestionsByVendorIdQuery } from "../../features/shop/shopApiSlice";
import "./SaleBussinesProfile.css";

const SaleBussinesProfile = () => {
  const [shopData, setShopData] = useState();
  const [suggest, setSuggest] = useState(0);
  const [suggestdetail, setSuggestdetail] = useState(0);
  const [suggestid, setSuggestid] = useState("");
  const [suggestdata, setSuggestdata] = useState();
  const [companyData, setCompanyData] = useState();
  const { id } = useParams();
  const currentUser = useSelector(
    (state) => state?.user?.name || state?.auth?.user,
  );
  const currentUserId = currentUser?._id || currentUser?.id;
  const isOwner = Boolean(
    currentUserId &&
      shopData?.userid &&
      String(currentUserId) === String(shopData.userid?._id || shopData.userid),
  );

  const { data: companyRes, isLoading: isCompanyLoading } =
    useGetCompanyByIdQuery(id, { skip: !id });
  const [getSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  useEffect(() => {
    if (companyRes?.data?.Company) {
      setShopData(companyRes.data.Company);
      setSuggestid(companyRes.data.Company._id);
    }
  }, [companyRes]);

  const suggestdatta = () => {
    if (shopData?._id) {
      getSuggestions(shopData._id)
        .unwrap()
        .then((res) => {
          setSuggestdata(res?.data[0]?.suggestions);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Container className="sale-business-profile">
      <Col md={12} lg={11} className="mx-auto">
        <Row className="sale-business-back-row">
          <Col>
            <BackArrow
              back={`/rawmaterial-business-property/${id}`}
              mystyle="sale-business-back-arrow"
            />
          </Col>
        </Row>
        <Row>
          <Col
            md={4}
            lg={3}
            className="p-0 sale-bussines-sidebar-col"
          >
            <BusinessPropertySideBar
              Add="Post Add"
              Name="Update Bussines Property"
              update="/update-property-form"
              post="/create-business-Ad"
              navigateTo="/update-property-form"
              shopData={shopData}
              setSuggest={setSuggest}
              suggestdatta={suggestdatta}
              companyData={companyData}
              id={id}
              isLoading={isCompanyLoading}
            />
          </Col>

          <Col md={8} lg={9} className="screenHeight custom_ps-4 sale-business-content">
            <div
              className="Form-Shadow sale-business-panel"
              style={{ backgroundColor: "#fafafa", minHeight: "100%" }}
            >
              <Row>
                <Col lg="6" className="sale-business-desktop-back">
                  <BackArrow
                    back={`/rawmaterial-business-property/${id}`}
                    mystyle="ps-4"
                  />
                </Col>
                <Col lg="6" className="mt-2 pe-4 mb-2 sale-business-actions">
                  <Managebuttons
                    businessurl="/business-properties"
                    id={id}
                    shopData={shopData}
                    isOwner={isOwner}
                  />
                </Col>
              </Row>

              <PropertyItemsCard
                urlPass="/business-property-owner-view"
                shopid={id}
                suggest={suggest}
                setSuggest={setSuggest}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
                post={`/create-business-Ad/${id}`}
                suggestdata={suggestdata}
                shopData={shopData}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};
export default SaleBussinesProfile;
